import {
  GET_ALL_VIDEOGAMES,
  GET_NAMES,
  GET_VIDEOGAME,
  GET_BY_GENRES,
  CREATE_VIDEOGAME,
  ORDER_BY,
  FILTER_BY_GENRES,
  GET_PLATFORMS,
  GET_PAGEONE,
  SEARCH_NAME,
} from "../actions/index";

const initialState = {
  allVideogames: [],
  videogames: [],
  videogame: [],
  genres: [],
  platforms: [],
};

function rootReducer(state = initialState, action) {
  switch (action.type) {
    //
    case GET_PAGEONE: //para traer la primera pagina
      return {
        ...state,
        allVideogames: action.payload, //de reserva
        videogames: action.payload,
      };

    case GET_ALL_VIDEOGAMES: //para mi home
      return {
        ...state,
        allVideogames: [...state.allVideogames, ...action.payload], //de reserva
        videogames: [...state.videogames, ...action.payload],
      };

    case GET_NAMES: //para mi componente de search
      return {
        ...state,
        allVideogames: action.payload, //de reserva
        videogames: action.payload,
      };

    case GET_VIDEOGAME: //para detalle
      return {
        ...state,
        videogame: action.payload,
      };
    case GET_BY_GENRES:
      return {
        ...state,
        genres: action.payload,
      };
    case CREATE_VIDEOGAME:
      return {
        ...state,
      };
    case ORDER_BY:
      let vgCopy = [...state.allVideogames]; //hago una copia de mi estado
      let ordenamiento;
      switch (action.payload) {
        case "All":
          ordenamiento = [...state.allVideogames];
          break;
        case "A-Z":
          ordenamiento = vgCopy.sort(function (a, b) {
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            return 0;
          });
          break;
        case "Z-A":
          ordenamiento = vgCopy.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return 1;
            }
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return -1;
            }
            return 0;
          });
          break;
        case "RatingAsc":
          ordenamiento = vgCopy.sort(function (a, b) {
            return a.rating - b.rating;
          });
          break;
        case "RatingDesc":
          ordenamiento = vgCopy.sort(function (a, b) {
            return b.rating - a.rating;
          });
          break;
        default:
          ordenamiento = vgCopy;
          break;
      }
      return {
        ...state,
        allVideogames: ordenamiento,
        videogames: ordenamiento,
      };
    case FILTER_BY_GENRES:
      let aux = [];
      if (action.payload) {
        aux = state.allVideogames.filter((e) => {
          if (e.genres.length === 0) {
            return e.genres;
          } else if (e.genres.some((e) => e.name === action.payload)) {
            return e.genres.map((el) => el.name);
          } else {
            return e.genres.includes(action.payload);
          }
        });
      } else {
        aux = state.allVideogames;
      }
      return {
        ...state,
        videogames: aux,
      };

    case GET_PLATFORMS:
      return {
        ...state,
        platforms: [...action.payload],
      };

    case SEARCH_NAME:
      return {
        ...state,
        videogames: state.allVideogames.filter((e) =>
          e.name.toLowerCase().includes(action.payload.toLowerCase())
        ),
      };

    default:
      return {
        ...state,
      };
  }
}

export default rootReducer;
